import React from 'react';
import PropTypes from 'prop-types';
import { Dthc } from '../../../Modules';
import TermsEditDesktop from './TermsEditDesktop';
import TermsEditMobile from './TermsEditMobile';
import styles from './Terms.scss';
import TermsBuilder from '../TermsBuilder/TermsBuilder';
import { Button, Grid } from 'semantic-ui-react';
import { RootConsumer } from '../../../RootComponent';

export default class TermsComponent extends React.Component {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    localTerms: PropTypes.string,
    reset: PropTypes.func.isRequired,
    terms: PropTypes.string,
    termsChangeHandler: PropTypes.func.isRequired,
    updateTerms: PropTypes.func.isRequired,
    builderSaveTerms: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      addingNew: false
    };
    this.addNew = this.addNew.bind(this);
    this.closeNew = this.closeNew.bind(this);
  }

  addNew() {
    this.setState({ addingNew: true });
  }

  closeNew() {
    this.setState({ addingNew: false });
  }

  render() {
    const {
      canEdit,
      localTerms,
      reset,
      terms,
      termsChangeHandler,
      updateTerms,
      builderSaveTerms
    } = this.props;
    const { addingNew } = this.state;
    const TermsShow = (
      <div
        style={{ padding: '1em', wordBreak: 'break-word' }}
        dangerouslySetInnerHTML={{ __html: terms }}
      />
    );
    return (
      <RootConsumer>
        {({ isMobile }) =>
          <div className={styles.terms}>
            {canEdit &&
              <div>
                {terms &&
                  <Dthc
                    desktop={TermsEditDesktop}
                    mobile={TermsEditMobile}
                    onChange={termsChangeHandler}
                    commitUpdate={updateTerms}
                    reset={reset}
                    value={localTerms}
                  >
                    {TermsShow}
                  </Dthc>}
                {!terms && !addingNew &&
                  <Grid columns={2} relaxed='very' stackable divided>
                    <Grid.Column>
                      <h3>Need a contract?</h3>
                      <TermsBuilder
                        save={builderSaveTerms}
                        trigger={<Button primary content='+ Generate Terms' />}
                      />
                      <br />
                      <br />
                      <p>
                        Generate a legally-binding, lawyer-approved contract in
                        minutes. Customized to your business. Valid in your state.
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <h3>Already have a contract?</h3>
                      <Button basic onClick={this.addNew} content='+ Add Terms' />
                      <br />
                      <br />
                      <p>
                        Paste your own contract terms and edit them right within
                        Cloverbook.
                      </p>
                    </Grid.Column>
                  </Grid>}
                {!terms && addingNew &&
                  <div>
                    {isMobile &&
                      <TermsEditMobile
                        onChange={termsChangeHandler}
                        commitUpdate={updateTerms}
                        reset={reset}
                        closeHandler={this.closeNew}
                        value={localTerms}
                        open={addingNew}
                      />}
                    {!isMobile &&
                      <TermsEditDesktop
                        onChange={termsChangeHandler}
                        commitUpdate={updateTerms}
                        reset={reset}
                        closeHandler={this.closeNew}
                        value={localTerms}
                      />}
                  </div>
                }
              </div>}
            {!canEdit && TermsShow}
          </div>}
      </RootConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Terms/Terms.js